import { atom, useAtomValue, useSetAtom } from 'jotai';

const isChatttUpdateState = atom<{
  value: boolean;
  updateInfo?: {
    version: string;
    releaseDate: string;
    releaseNotes?: {
      [k: string]: {
        content: string;
        title: string;
      };
    };
  };
}>({
  value: false,
  updateInfo: undefined,
});

export const useIsChatttUpdate = () => useAtomValue(isChatttUpdateState);
export const useSetIsChatttUpdate = () => useSetAtom(isChatttUpdateState);

const isFettUpdateState = atom<{
  value: boolean;
  updateInfo?: {
    name: string;
    version: string;
  };
}>({
  value: false,
  updateInfo: undefined,
});

export const useIsFettUpdate = () => useAtomValue(isFettUpdateState);
export const useSetIsFettUpdate = () => useSetAtom(isFettUpdateState);

const updaterVisibleState = atom(false);

export const useUpdaterVisible = () => useAtomValue(updaterVisibleState);
export const useSetUpdaterVisible = () => useSetAtom(updaterVisibleState);
